var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"o-Container":""}},[_c('h1',[_vm._v(_vm._s(_vm.octopus.username))]),_vm._v(" "),_c('div',[_vm._v("一般VUE项目分为首页、登陆页、内页，3个大组件，内部分支为无数个细小组件。")]),_vm._v(" "),_c('div',[_vm._v("参数："+_vm._s(_vm.$route.params.id)+"="+_vm._s(_vm.$route.params.key)+"="+_vm._s(_vm.$route.query.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e9a7e3e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/MarcoTest.vue
// module id = null
// module chunks = 